import type { BankAccountType } from '@api';
import { FormProvider } from 'react-hook-form';
import {
  BankAccountFormFields,
  BankAccountFormSchemaType,
  useEditBankAccountForm,
} from '../../../../common';

type EditBankAccountFormPropsType = {
  bankAccount: BankAccountType;
  onClose: () => void;
  onSubmit: (data: BankAccountFormSchemaType) => void;
};

export const EditBankAccountForm: React.FC<EditBankAccountFormPropsType> = ({
  bankAccount,
  onSubmit,
  onClose,
}) => {
  const form = useEditBankAccountForm(bankAccount);

  const handleSubmit = async (
    data: BankAccountFormSchemaType
  ): Promise<void> => {
    await onSubmit(data);
    onClose();
  };

  return (
    <FormProvider {...form}>
      <form onSubmit={form.handleSubmit(handleSubmit)}>
        <BankAccountFormFields onClose={onClose} />
      </form>
    </FormProvider>
  );
};
